module.exports = __webpack_public_path__ + "img/hubei_unicom_bsp.9e0256c5.png";